













































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import {FIELD_EVENTS_INSTANCE, VueOnMapType} from '@/fields/field-events';

@Component({
  components: {AmetrasTextFieldTemplate},
  mixins: [BindAttrs]
})
export default class AmetrasPhoneFieldTemplate extends Vue {

  @Prop() noValidate!: boolean;
  @Prop() readonly!: boolean;

  @Prop({
    default: false
  }) required!: boolean;
  /**
   * Indicates that all errors should be shown
   */
  @Prop() forceShowErrors!: boolean;

  rules = [(currentValue: string) => {
    if (!this.noValidate) {
      if (this.required && (this.forceShowErrors || !this.readonly) && (!currentValue || currentValue.trim().length === 0)) {
        return 'Bitte geben Sie eine gültige Telefonnummer an!';
      }
    }
    return !this.$attrs.error; // if any error from outside, return false
  }];

  passthroughAllEventsVueOnMap: VueOnMapType =
      FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
        this.$emit(eventName, eventArgs);
      });

  private isValidPhone() {
    return this.$attrs.value;
  }

  private inDataTable() {
    return this.$attrs['style-context'] && this.$attrs['style-context'] === 'DATATABLE';
  }

  private openPhoneClient() {
    if (this.$attrs.value) {
      // first replace leading zero with +49 (we just assert germany in that case!)
      let finalizedPhone: string = this.$attrs.value;
      if (finalizedPhone.startsWith('0')) {
        finalizedPhone = '+49' + finalizedPhone.slice(1);
      }

      window.location.href = `tel:${finalizedPhone}`;
    }
  }
}
